import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import advanced from 'dayjs/plugin/advancedFormat';

dayjs.extend(timezone);
dayjs.extend(utc);
dayjs.extend(advanced);

export const convertToEasternTimezone = (input: Date | string) => {
  const curTz = dayjs(input).tz(dayjs.tz.guess(), true).format();
  const val = dayjs(curTz).tz('America/Toronto');
  return val;
};
